import { render, staticRenderFns } from "./CompetenceLibelleManager.vue?vue&type=template&id=36d2e0b8&scoped=true&"
import script from "./CompetenceLibelleManager.vue?vue&type=script&lang=js&"
export * from "./CompetenceLibelleManager.vue?vue&type=script&lang=js&"
import style0 from "./CompetenceLibelleManager.vue?vue&type=style&index=0&id=36d2e0b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d2e0b8",
  null
  
)

export default component.exports